/* eslint-disable no-undef */
import Backbone from 'backbone';
import $ from 'jquery';
import ko from 'knockout';
import _ from 'underscore';
import ViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adGroupAdsEditor';
import EditorView from '@bingads-webui-campaign-legacy/crud-ad/view/adEditor';
import createTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adGroupAdsEditor.pug';
import adListTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adList.pug';
import adPreviewTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adPreview.pug';
import {combineText } from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsPreview/expandedTextAd';
import SingleListBox from '@bingads-webui-component-legacy/single-list-box/view/singleListBox';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import popup from '@bingads-webui-component-legacy/dialog/popup';
import getDomain from '@bingads-webui-campaign-legacy/crud-ad/service/getDomain';
import pageContext from '@bingads-webui-static-legacy/page-context';
import {types as campaignTypes} from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/campaignType';
import { getExpandedTextAdDisplayUrl, getDynamicSearchAdDisplayUrl } from '@bingads-webui-campaign-legacy/crud-ad/service/displayUrl';
import { getTitlePreview, getDescPreview } from '@bingads-webui-campaign/summary-grid-helper';
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const EditorForm = dialogDecorator.decorate(EditorView, {
  position: 'center',
  maxWidth: 2000,
  popupFront: '.navbar-fixed-top',
});

const EditorPanel = panelDecorator(EditorView, {
  panelClassName: 'ad-editor-panel',
  i18n,
  panelReadyAriaLabel: i18n.getString('Ad editor side panel opened'),
});

const DefaultPageSize = 9;
const DefaultMaxAdsCount = 50;

export default class AdGroupAdsEditor extends Backbone.View {
  initialize({
    adGroups = [{Id: '', Name: '', Keywords: []}],
    adGroupId = '',
    Campaign: { Id: campaignId = '', DomainName: campaignDomain = '', DynamicDescriptionEnabled: isDynamicDescriptionEnabled = false } = {},
    idField = 'Id',
    pageSize = DefaultPageSize,
    maxAdsCount = DefaultMaxAdsCount,
    showAdGroupInfo = true,
    isSaveToServer = true,
    Language: language = null,
    Languages: languages = [],
    campaignType = 'search',
    defaultLandingPageUrl = '',
    usePanel = false,
    isForVNext = false,
    activityLogger,
    adGroupType = null,
    isMixedModeCampaignCreation = false,
    newI18n,
    perfMarker,
    serverContext,
  } = {}) {
    this.showAdGroupInfo = showAdGroupInfo;
    this.adGroupId = adGroupId;
    this.adGroup = _.find(adGroups, (adg) => String(adg.Id) === String(adGroupId)) || {};
    this.idField = idField;
    this.maxAdsCount = maxAdsCount;
    this.campaignId = campaignId;
    this.isSaveToServer = isSaveToServer;
    this.language = language;
    this.languages = languages || [];
    this.pageSize = pageSize;
    this.campaignType = campaignType;
    this.defaultLandingPageUrl = defaultLandingPageUrl;
    this.campaignDomain = _.result(_.first(_.result(pageContext.CurrentCampaign, 'CampaignSettings')), 'DomainName', campaignDomain);
    this.isDynamicDescriptionEnabled = _.result(_.first(_.result(pageContext.CurrentCampaign, 'CampaignSettings')), 'DynamicDescriptionEnabled', isDynamicDescriptionEnabled);
    this.isVanityUrlEnabled = pageContext.Permissions.IsVanityUrlEnabled;
    this.usePanel = usePanel;
    this.activityLogger = activityLogger;
    this.isForVNext = isForVNext;
    this.adGroupType = adGroupType;
    this.inlineSuggestionsEnabled = pageContext.Permissions.IsRSASuggestionCMUIEnabled;
    this.newI18n = newI18n;
    this.adEditorListContainer = '.ad-editor-list-group';
    this.perfMarker = perfMarker;
    this.serverContext = serverContext;

    const map = {
      copy: this._copyAd,
      edit: this._editAd,
      remove: this._deleteAd,
      copyToSome: this._copyAdToSomeAdGroups,
      copyToOthers: this._copyAdToAllOtherAdGroups,
    };

    this.itemActions = _.reduce(map, (memo, value, key) => {
      memo[key] = {
        callback: _.bind(value, this),
      };

      return memo;
    }, {}, this);

    this.viewModel = new ViewModel({
      idField,
      maxAdsCount,
      adGroupId,
      adGroups,
      isMixedModeCampaignCreation,
    });

    this.on('update:domainName', (DomainName) => {
      this.campaignDomain = DomainName;
    });
    this.on('update:dynamicDescriptionEnabled', (dynamicDescriptionEnabled) => {
      this.isDynamicDescriptionEnabled = dynamicDescriptionEnabled;
    });
  }

  get events() {
    return {
      'click .create-ad': '_createAd',
    };
  }

  render() {
    this.$el.html(createTemplate({
      i18: i18n,
      showAdGroupInfo: this.showAdGroupInfo,
    }));
    ko.applyBindings(this.viewModel, this.el);

    this._initializeListView();

    return this;
  }

  remove() {
    if (this.editor) {
      this.editor.remove();
      delete this.editor;
    }
    super.remove();
  }

  getAds() {
    return this.viewModel.getAds();
  }

  logActivity(message) {
    if (this.activityLogger) {
      this.activityLogger.signal(message, 'ad group ads editor');
    }
  }

  _getData() {
    return (options, cb) => {
      cb(null, {
        items: this.viewModel.ads,
        total: this.viewModel.ads.length,
      });
    };
  }

  _processItem(item/*, id*/) {
    if (item.action) {
      item.isFirst = this.viewModel.isEmpty();
    } else {
      const type = _.result(item, 'Type');

      item.adGroups = this.viewModel.allAdGroupsInfo();
      if (type === 'ExpandedText') {
        item.title = `${item.TitlePart1} | ${item.TitlePart2}`;

        if (item.TitlePart3) {
          item.title = `${item.title} | ${item.TitlePart3}`;
        }

        item.displayUrl = getExpandedTextAdDisplayUrl(_.first(item.FinalUrls), item.DisplayUrl, item.Path1, item.Path2);
        if (item.TextPart2) {
          item.text = combineText(item.Text, item.TextPart2);
        } else {
          item.text = item.Text;
        }
      } else if (type === 'ResponsiveSearch') {
        item.text = getDescPreview(_.map(item.Descriptions, (i) => ({
          Text: i.Asset.Text,
          PinnedField: i.PinnedField,
        })));
        item.title = getTitlePreview(_.map(item.Headlines, (i) => ({
          Text: i.Asset.Text,
          PinnedField: i.PinnedField,
        })));
        item.displayUrl = getExpandedTextAdDisplayUrl(_.first(item.FinalUrls), item.DisplayUrl, item.Path1, item.Path2);
      } else if (type === 'DynamicSearch') {
        item.displayUrl = getDynamicSearchAdDisplayUrl(getDomain(this.campaignDomain), item.Path1, item.Path2);
        if (item.TextPart2) {
          item.text = combineText(item.Text, item.TextPart2);
        } else {
          item.text = item.Text;
        }
      }
    }

    item.hasMultiAdgroups = this.viewModel.hasMultiAdgroups();
    this.updateAttributeForListItem(this.adEditorListContainer);

    return item;
  }

  _initializeListView() {
    this.viewModel.slb = new SingleListBox({
      el: this.$el.find('.ads-creative'),
      itemActions: this.itemActions,
      processItem: _.bind(this._processItem, this),
      data: {
        sourceItems: _.bind(this._getData(), this),
        useCallbackForFetchOnly: true,
        itemIdField: this.idField,
        pageSize: this.pageSize,
      },
      templates: {
        layoutTemplate: adListTemplate({ i18n }),
        itemLayoutTemplate: adPreviewTemplate({
          i18n,
          isForVNext: this.isForVNext,
          adGroupId: this.adGroupId,
        }),
        listContainerSelector: this.adEditorListContainer,
      },
    }).render();

    // The following code to is used to fix accessibility on ad panel.
    _.defer(() => {
      $(this.adEditorListContainer).attr('role', 'list');
      $(this.adEditorListContainer).on('focus', () => {
        $(this.adEditorListContainer).removeAttr('aria-activedescendant tabindex');
      });
      this.updateAttributeForListItem(this.adEditorListContainer);
    });
  }

  copyAdFromOtherAdGroup(ad) {
    this._copyAd(ad);
  }

  isEmpty() {
    const empty = this.viewModel.isEmpty();

    this.viewModel.alertMessage(empty ? i18n.get('AdGroup_Validation_NoCreatedAd') : '');
    return empty;
  }

  changes() {
    return this.viewModel.changes();
  }

  _copyAdToAllOtherAdGroups(ad) {
    this.logActivity('click copy ad to all other ad groups');
    this.trigger('copyToOthers', {
      ad,
      sourceId: this.adGroupId,
    });

    this.trigger('ads:changed');
  }

  _copyAdToSomeAdGroups(ad) {
    this.logActivity('click copy ad to some ad groups');
    const targetAdGroupIds = this.$(`.copyToSome[data-id=${ad[this.idField]}] input:checked`).map(function () {
      return this.dataset.adgroupid; //eslint-disable-line
    }).get();

    if (_.isEmpty(targetAdGroupIds)) {
      popup.alert(i18n.get('AdGroup_Validation_NoOneSelected'));
    } else {
      this.trigger('copyToSome', {
        targetAdGroupIds,
        ad,
      });

      this.trigger('ads:changed');
    }
  }

  _deleteAd(ad) {
    this.logActivity('remove ad clicked');
    if (popup.confirm(i18n.get('Ad_Delete_Warning'))) {
      this.viewModel.onDelete(ad);

      this.trigger('ads:changed');
      this.logActivity('ad removed');

      this.updateAttributeForListItem(this.adEditorListContainer);
      if (window.App.views.alertCenter) {
        window.App.views.alertCenter.showConfirmation(this.newI18n.getString(_TL_('Ad removed successfully.')));
      }
    }
  }

  _createAd() {
    if (!this._hasMaxAds()) {
      this._editAd(null);
    }
    this.updateAttributeForListItem(this.adEditorListContainer);
  }

  _hasMaxAds() {
    if (this.viewModel.isFull()) {
      this.viewModel.alertMessage(i18n.get('AdGroup_Validation_MaxCreatedAds', {
        name: _.property('Name')(this.viewModel.adGroup()),
        count: this.maxAdsCount,
      }));
      return true;
    }

    return false;
  }

  _copyAd(ad) {
    const focusId = $(document.activeElement).parents('.adEditor-listitem').attr('data-id');

    this.logActivity('copy ad clicked');
    if (!this._hasMaxAds()) {
      this.viewModel.onCopy(ad);

      this.trigger('ads:changed');
      this.updateAttributeForListItem(this.adEditorListContainer);

      if (window.App.views.alertCenter) {
        window.App.views.alertCenter.showConfirmation(this.newI18n.getString(_TL_('Ad copied successfully.')));
        if (focusId) {  // Focus on the copy button after the copy action
          $(`.adEditor-listitem[data-id=${focusId}]`).find('.itemAction-copy').trigger('focus');
        }
      }
    }
  }

  _onClose() {
    if (this.editor) {
      this.editor.remove();
      delete this.editor;
    }
    this.updateAttributeForListItem(this.adEditorListContainer);
  }

  _handleCreatedAd(ext) {
    this.viewModel.onCreate(ext);
    this.trigger('ads:changed');
    this.updateAttributeForListItem(this.adEditorListContainer);
  }

  _handleUpdatedAd(ext, ad) {
    this.viewModel.onUpdate(ext, ad);
    this.trigger('ads:changed');
    this.updateAttributeForListItem(this.adEditorListContainer);
  }

  _editAd(ad) {
    if (_.isEmpty(ad)) {
      this.logActivity('create ad clicked');
    } else {
      this.logActivity('edit ad clicked');
    }

    if (this.editor) {
      this.editor.remove();
    }

    const campaignType = _.result(pageContext.CurrentCampaign, 'CampaignType') || campaignTypes[this.campaignType];

    if (this.usePanel) {
      this.editor = new EditorPanel({
        newI18n: this.newI18n,
        model: _.isEmpty(ad) ? ad : this.viewModel.findAd(ad.Id),
        externalCachedImageExtensionChanges: this.viewModel.getCachedImageExtensionChanges(),
        onCachedImageExtensionChanged: this.viewModel.syncTheExtension.bind(this.viewModel),
        campaignId: Number(this.campaignId),
        adGroupId: Number(this.adGroupId),
        adGroupType: this.adGroupType || this.adGroup.AdGroupType,
        campaignType,
        isForVNext: this.isForVNext,
        title: i18n.get(ad ? 'Ad_EditAd' : 'Ad_CreateAd'),
        isSaveToServer: this.isSaveToServer,
        isTraditionalChinese: this.language === 'TraditionalChinese' || _.contains(this.languages, 'All') || _.contains(this.languages, 'TraditionalChinese'),
        inlineSuggestionsEnabled: this.inlineSuggestionsEnabled,
        defaultLandingPageUrl: this.defaultLandingPageUrl,
        campaignDomain: this.campaignDomain,
        isDynamicDescriptionEnabled: this.isDynamicDescriptionEnabled,
        activityLogger: this.activityLogger,
        eventsToActions: [{
          event: 'cancel close',
          action: this._onClose.bind(this),
        }, {
          event: 'created',
          action: (ext) => this._handleCreatedAd(ext),
        }, {
          event: 'updated',
          action: (ext) => this._handleUpdatedAd(ext, ad),
        }],
        onClose: this._onClose.bind(this),
        isAdgroupCreation: true,
        perfMarker: this.perfMarker,
        serverContext: this.serverContext,
      }).render();
    } else {
      this.editor = new EditorForm({
        newI18n: this.newI18n,
        model: _.isEmpty(ad) ? ad : this.viewModel.findAd(ad.Id),
        campaignId: Number(this.campaignId),
        adGroupId: Number(this.adGroupId),
        adGroupType: this.adGroupType || this.adGroup.AdGroupType,
        campaignType,
        isForVNext: this.isForVNext,
        title: i18n.get(ad ? 'Ad_EditAd' : 'Ad_CreateAd'),
        isSaveToServer: this.isSaveToServer,
        isTraditionalChinese: this.language === 'TraditionalChinese' || _.contains(this.languages, 'All') || _.contains(this.languages, 'TraditionalChinese'),
        inlineSuggestionsEnabled: this.inlineSuggestionsEnabled,
        defaultLandingPageUrl: this.defaultLandingPageUrl,
        campaignDomain: this.campaignDomain,
        activityLogger: this.activityLogger,
        isAdgroupCreation: true,
        perfMarker: this.perfMarker,
      }).render();

      this.editor.on('created', (ext) => this._handleCreatedAd(ext));

      this.editor.on('updated', (ext) => this._handleUpdatedAd(ext, ad));

      this.editor.on('cancel close', this._onClose.bind(this));
    }
    this.updateAttributeForListItem(this.adEditorListContainer);
  }

  clearAlertMessages() {
    this.viewModel.alertMessage('');
    this.viewModel.duplicateAlertMessage('');
  }

  updateAttributeForListItem(listContainer) {
    $(listContainer).removeAttr('aria-activedescendant');
    let items = $(listContainer).children();

    _.each(items, (item) => {
      $(item).attr('role', 'listitem');
      $(item).removeAttr('aria-selected');
    });
  }
}
